import apiV2 from "api-v2";

import type {
	ApproveRevisionPayload,
	DeclineRevisionPayload,
	QuoteRevisionRequest,
	QuoteRevisionSnapshot,
	RequestRevisionPayload,
	RevisionRequest,
	SaveQuoteRevisionPayload,
} from "../types/revision.type";

export const requestRevision = async (
	inviteId: number,
	payload: RequestRevisionPayload
): Promise<RevisionRequest> => {
	const response = await apiV2.post<{ data: RevisionRequest }>(
		`rfx-invite/${inviteId}/revision-requests`,
		payload
	);
	return response.data.data;
};

export const getPendingRevisionRequest = async (
	inviteId: number
): Promise<RevisionRequest | null> => {
	const response = await apiV2.get<{ data: RevisionRequest | null }>(
		`rfx-invite/${inviteId}/revision-requests/pending`
	);
	return response.data.data;
};

export const approveRevisionRequest = async (
	inviteId: number,
	requestId: number,
	payload: ApproveRevisionPayload
): Promise<RevisionRequest> => {
	const response = await apiV2.patch<{ data: RevisionRequest }>(
		`rfx-invite/${inviteId}/revision-requests/${requestId}/approve`,
		payload
	);
	return response.data.data;
};

export const declineRevisionRequest = async (
	inviteId: number,
	requestId: number,
	payload: DeclineRevisionPayload
): Promise<RevisionRequest> => {
	const response = await apiV2.patch<{ data: RevisionRequest }>(
		`rfx-invite/${inviteId}/revision-requests/${requestId}/decline`,
		payload
	);
	return response.data.data;
};

export const saveQuoteRevision = async (
	request: QuoteRevisionRequest,
	payload: SaveQuoteRevisionPayload
): Promise<QuoteRevisionSnapshot & { isQuoteTabValid?: boolean }> => {
	const response = await apiV2.post<{
		additional?: { is_quote_tab_valid?: boolean };
		data: QuoteRevisionSnapshot;
	}>(
		`rfx-invite/${request.inviteId}/quote-revisions/${request.quoteId}`,
		payload
	);
	return {
		...response.data.data,
		isQuoteTabValid: response.data.additional?.is_quote_tab_valid,
	};
};

export const getQuoteRevisions = async (
	request: QuoteRevisionRequest
): Promise<QuoteRevisionSnapshot[]> => {
	const response = await apiV2.get<{ data: QuoteRevisionSnapshot[] }>(
		`rfx-invite/${request.inviteId}/quote-revisions/${request.quoteId}`
	);
	return response.data.data;
};

/**
 * Batch: return all revisions for every quote table in the RFx, keyed by quote ID.
 * Replaces N individual getQuoteRevisions calls with a single request.
 */
export const getAllQuoteRevisions = async (
	inviteId: number
): Promise<Record<number, QuoteRevisionSnapshot[]>> => {
	const response = await apiV2.get<{ data: Record<number, QuoteRevisionSnapshot[]> }>(
		`rfx-invite/${inviteId}/quote-revisions`
	);
	return response.data.data;
};

export const submitRevision = async (inviteId: number): Promise<void> => {
	await apiV2.post(`rfx-invite/${inviteId}/submit-revision`);
};
